import { useCallback, useState } from 'react';

import { datasetsDatasourcesHarvestPartialUpdate } from '../openapi/operations/datasetsDatasourcesHarvestPartialUpdate';

/** `vydej_harvest_already_running`: zdroj už čeká nebo běží, skutečný stav dodá obnovení seznamu. */
const HTTP_CONFLICT = 409;

export type UseDatasourceHarvest = {
  harvest(): Promise<void>;
  /** Od kliknutí do doběhnutí obnovení seznamu; do té doby stav řádku ještě neodpovídá serveru. */
  isPending: boolean;
  hasFailed: boolean;
  dismissFailure(): void;
};

export const useDatasourceHarvest = (
  id: number,
  refresh: () => Promise<void>,
): UseDatasourceHarvest => {
  const [isPending, setIsPending] = useState(false);
  const [hasFailed, setHasFailed] = useState(false);

  const harvest = useCallback(async () => {
    setIsPending(true);
    setHasFailed(false);

    const response = await datasetsDatasourcesHarvestPartialUpdate({ query: { id }, request: {} });

    if (response.ok || response.status === HTTP_CONFLICT) {
      await refresh();
    } else {
      setHasFailed(true);
    }

    setIsPending(false);
  }, [id, refresh]);

  const dismissFailure = useCallback(() => setHasFailed(false), []);

  return { harvest, isPending, hasFailed, dismissFailure };
};
